// global functions
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function formatProductPriceNoZeros(price, currencyCode = window.currencyCode) {
  const formattedPrice = price / 100;
  let minimumFractionDigits = 0;
  if (!Number.isInteger(formattedPrice)) {
    minimumFractionDigits = 2
  }
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: minimumFractionDigits,
  });

  return formatter.format(formattedPrice);
}

function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function deviceSupportHover() {
  const supportsHover = window.matchMedia('(hover: hover)').matches;

  return supportsHover;
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function convertTextToSlug(value) {
  if( value) {
    return value
      .normalize('NFD') // Decompose accented characters (é -> e + ́)
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (combining marks)
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/\//g, "-")
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  } else {
    return value
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (let key in params) {
    let hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    let value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    let optSelectedIndex = this.countryEl.options[this.countryEl.selectedIndex];
    let raw = optSelectedIndex.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        let opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('.menu-drawer-container');
    this.header = this.closest('.shopify-section.section-header');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button.menu-drawer__close').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    this.querySelectorAll('button.header__icon--menu').forEach((button) =>
      button.addEventListener('click', this.openMenuDrawer.bind(this))
    );

    this.querySelectorAll('button.menu-drawer__close-button').forEach((button) =>
      button.addEventListener('click', this.closeSubMenuDrawer.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        if(!summaryElement.closest('.facets__filter-sort')) {
          summaryElement.setAttribute('aria-expanded', true);
        }
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        document.body.classList.add('menu-submenu--open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    // Apply immediate visual changes for better INP
    this.closest('menu-drawer')?.classList.add('drawer__open');
    this.mainDetailsToggle.classList.add('menu-opening');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    if(!summaryElement.closest('.facets__filter-sort')) {
      summaryElement.setAttribute('aria-expanded', true);
    }

    // Defer focus trapping to avoid blocking the main interaction
    requestAnimationFrame(() => {
      if(this.mainDetailsToggle.classList.contains('mobile-facets__disclosure')) {
        trapFocus(this.mainDetailsToggle, this.mainDetailsToggle.querySelector('.mobile-facets__inner'));
      } else {
        trapFocus(this.mainDetailsToggle, summaryElement);
      }
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.closest('menu-drawer')?.classList.remove('drawer__open');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('menu-submenu--open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('.menu-drawer-container');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    document.body.classList.remove('menu-submenu--open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    detailsElement.classList.remove('menu-opening');
    document.body.classList.remove('body-menu-open');
    this.header.classList.remove('menu-open');
    // Closes all open menu item
    const openedSubmenu = detailsElement.querySelector('.submenu-open');
    if (openedSubmenu) {
      openedSubmenu.classList.remove('submenu-open');
      document.body.classList.remove('menu-submenu--open');
      const openedSubmenuDetailsEl = openedSubmenu.querySelector('details.menu-opening');
      openedSubmenuDetailsEl.classList.remove('menu-opening');
      openedSubmenuDetailsEl.removeAttribute('open')
    }
    if(!detailsElement.closest('.facets__filter-sort')) {
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    }
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeSubMenuDrawer(event) {
    const detailsElement = event.currentTarget.closest('details');
    const parentMenuElement = detailsElement.closest('.submenu-open');

    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    document.body.classList.remove('menu-submenu--open');
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    // Cache DOM elements and calculations during construction
    this.#cacheElements();
  }

  // Private method to cache expensive DOM queries
  #cacheElements() {
    this.header = document.querySelector('.section-header');
    this.announcementBar = document.querySelector('announcement-bar');
    this.headerWrapper = this.closest('.header-wrapper');
    this.borderOffset = this.headerWrapper?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
  }

  openMenuDrawer(summaryElement) {
    // Immediate visual feedback - most critical for INP
    this.header?.classList.add('menu-open');
    document.body.classList.add('body-menu-open');
    this.mainDetailsToggle.classList.add('menu-opening');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Handle scroll positioning efficiently
    if(window.scrollY === 0 && this.announcementBar) {
      // Use instant scroll instead of smooth to avoid delay
      window.scrollTo({
        top: this.announcementBar.clientHeight,
        behavior: 'instant',
        left: 0
      });
    }

    // Defer expensive calculations using requestAnimationFrame
    requestAnimationFrame(() => {
      if (this.header) {
        const headerBottom = this.header.getBoundingClientRect().bottom - this.borderOffset;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerBottom)}px`);
      }
    });

    // Handle focus management
    const summaryEl = summaryElement.target || summaryElement;
    if(summaryEl && !summaryEl.closest('button.header__icon--menu')) {
      summaryElement.setAttribute('aria-expanded', true);
      // Defer focus trapping to next frame to avoid blocking the interaction
      requestAnimationFrame(() => {
        trapFocus(this.mainDetailsToggle, summaryElement);
      });
    }

    // Defer resize listener addition
    requestAnimationFrame(() => {
      window.addEventListener('resize', this.onResize);
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('body-menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('#search-dialog');
    this.desktopTrigger = this.querySelector('.header-search__trigger--desktop');
    this.mobileTrigger = this.querySelector('.header-search__trigger--mobile');
    this.searchInput = this.querySelector('.search-modal__input');
    this.cancelButton = this.querySelector('.search-modal__cancel');
    this.mobileBreakpoint = window.matchMedia('(max-width: 989px)');

    this.bindEvents();
  }

  bindEvents() {
    if (this.desktopTrigger) {
      this.desktopTrigger.addEventListener('click', this.openSearchModal.bind(this));
    }

    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener('click', this.openSearchModal.bind(this));
    }

    if (this.cancelButton) {
      this.cancelButton.addEventListener('click', this.closeSearchModal.bind(this));
    }

    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape' && this.classList.contains('search-modal--open')) {
        this.closeSearchModal();
      }
    });
  }

  openSearchModal() {
    const isMobile = this.mobileBreakpoint.matches;

    const announcementBar = document.querySelector('announcement-bar');
    if (window.scrollY === 0 && announcementBar) {
      window.scrollTo({ top: announcementBar.clientHeight, behavior: 'instant', left: 0 });
    }

    this.classList.add('search-modal--open');

    this.savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.style.width = '100%';

    this.dialog.removeAttribute('tabindex');
    this.showBackdrop();

    requestAnimationFrame(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
      trapFocus(this.dialog, this.searchInput);
    });
  }

  closeSearchModal() {
    if (!this.classList.contains('search-modal--open')) return;

    this.classList.remove('search-modal--open');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo({ top: this.savedScrollY || 0, behavior: 'instant' });

    this.dialog.setAttribute('tabindex', -1);
    this.hideBackdrop();

    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch && predictiveSearch.close) {
      predictiveSearch.close(true);
    }

    removeTrapFocus();

    const activeTrigger = this.mobileBreakpoint.matches
      ? this.mobileTrigger
      : this.desktopTrigger;
    if (activeTrigger) activeTrigger.focus();
  }

  showBackdrop() {
    if (!this.backdrop) {
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'search-backdrop';
      this.backdrop.addEventListener('click', this.closeSearchModal.bind(this));
    }
    document.body.appendChild(this.backdrop);
  }

  hideBackdrop() {
    if (this.backdrop && this.backdrop.parentNode) {
      this.backdrop.parentNode.removeChild(this.backdrop);
    }
  }
}

customElements.define('search-modal', SearchModal);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.modalName = this.dataset.modalName;

    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }

    if (this.getAttribute('moved') === 'true') this.moved = true;
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    if(this.modalName) {
      document.body.classList.add(this.modalName)
    }

    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    if(this.modalName) {
      document.body.classList.remove(this.modalName)
    }
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true, preventAutoplay = false) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (!preventAutoplay && deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionLabelValues();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionLabelValues() {
    this.querySelectorAll('.product-form__input--dropdown').forEach((wrapper) => {
      const select = wrapper.querySelector('select');
      const selectedSpan = wrapper.querySelector('.option-selected-value');
      if (!select || !selectedSpan) return;

      const value = select.options[select.selectedIndex]?.textContent?.trim();
      if (value) {
        selectedSpan.textContent = `${value}`;
        if (selectedSpan.classList.contains('selected__color')) {
          selectedSpan.dataset.selectedColor = value;
        }
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const color = this.currentVariant[`option${parseInt(this.dataset.colorOptionIndex) + 1 }`]

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      if (color) {
        const handle = color.replace(/\s+/g, '-').toLowerCase();
        mediaGallery.dispatchEvent(new CustomEvent('colorChanged', {
          detail: {
            color: handle,
          },
        }));
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);

        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // update price
        const priceDestination = html.querySelector('.price').innerHTML
        document.querySelectorAll('.price').forEach(element => {
          element.innerHTML = priceDestination
        });

        // update button text
        const buyButtonInnerHtml = html.querySelector('[name="add"]').innerHTML
        document.querySelectorAll('[name="add"]').forEach(element => {
          element.innerHTML = buyButtonInnerHtml
        });

        // update selected option label values (color, size, etc.)
        const variantPickerSelector = `#variant-radios-${this.dataset.section}, #variant-selects-${this.dataset.section}`;
        const variantPickerDestination = document.querySelector(variantPickerSelector);
        const variantPickerSource = html.querySelector(variantPickerSelector);

        if (variantPickerSource && variantPickerDestination) {
          const sourceValues = variantPickerSource.querySelectorAll('.option-selected-value');
          const destValues = variantPickerDestination.querySelectorAll('.option-selected-value');
          sourceValues.forEach((source, index) => {
            if (destValues[index]) {
              destValues[index].innerHTML = source.innerHTML;
              if (source.dataset.selectedColor) {
                destValues[index].dataset.selectedColor = source.dataset.selectedColor;
              }
            }
          });
        }

        // legacy fallback for color-only sync
        const selectedColorSource = html.querySelector('.selected__color');
        const selectedColordestination = document.querySelector(`#variant-radios-${this.dataset.section} .selected__color`);

        if (selectedColorSource && selectedColordestination && !variantPickerSource) {
          selectedColordestination.innerHTML = selectedColorSource.innerHTML;
        }

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      const value = checked?.value;
      const selectedSpan = fieldset.querySelector('.option-selected-value');
      if (selectedSpan && value) {
        selectedSpan.textContent = `${value}`;
        if (selectedSpan.classList.contains('selected__color')) {
          selectedSpan.dataset.selectedColor = value;
        }
      }
      return value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// check all text ® icon and wrap in sup tag
document.body.querySelectorAll('body *:not(script):not(style)').forEach((el) => {
  if(el.children.length <= 0) {
    const elHtml = el.innerHTML;
    if(elHtml && elHtml.indexOf('®') >= 0) {
      const toPrint = elHtml.trim().replaceAll("®", "<sup class='trademark-symbol'>®</sup>");
      el.innerHTML = toPrint;
    }
  }
});

class VideoBlock extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.button = this.querySelector('.video-handler')
  }

  connectedCallback() {
    this.button.addEventListener('click', (e) => {
      if(this.video.paused) {
        e.target.setAttribute('data-video-state', 'playing')
        this.video.play()
      } else {
        e.target.setAttribute('data-video-state', 'paused')
        this.video.pause()
      }
    })
  }
}

customElements.define('video-block', VideoBlock)

/**
  This code ensures that keyboard navigation stays "trapped" within the menu dialog.
**/
// Function to get all focusable elements inside the dialog
function getFocusableElements(dialog) {
  return dialog.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
  );
}

// Select the dialog element with the ARIA role of "dialog"
let dialog = document.querySelector('[role="dialog"]');

// Event listener for trapping focus within the dialog
dialog.addEventListener('keydown', function(e) {
  // Dynamically get all focusable elements inside the dialog
  let focusableElements = getFocusableElements(dialog);

  // Ensure there are focusable elements
  if (focusableElements.length === 0) return;

  // Determine the first and last focusable elements
  let firstFocusableElement = focusableElements[0];
  let lastFocusableElement = focusableElements[focusableElements.length - 1];

  // Trap focus within the dialog
  if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
    e.preventDefault(); // Prevent default Tab behavior
    lastFocusableElement.focus(); // Move focus to the last element
  } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
    e.preventDefault(); // Prevent default Tab behavior
    firstFocusableElement.focus(); // Move focus to the first element
  }
});

// opens menu drawer is form is submitted in the menu drawer on mobile
if (location.hash.indexOf('NewsletterFormDrawer') >= 0) {
  document.querySelector('.header__icon--menu.header__icon--summary').click();
}

// check if url contains access=true then set localstorage restricted to disabled and based on that show the buy button on the restricted products
// Function to get the value of a query parameter from the URL
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

const access = getQueryParam('access');

if (access) {
  setCookie('restricted', 'disabled', 14);
}

// Event listener to scroll to a section when a link is clicked
const scrollLinks = document.querySelectorAll('[data-target-section-id]');

scrollLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const targetSection = document.querySelector(`[data-target-id=${link.dataset.targetSectionId}]`);
    const headerHeight = document.querySelector('.section-header').clientHeight;

    if (targetSection) {
      window.scrollTo({
        top: targetSection.offsetTop - headerHeight,
        behavior: 'smooth'
      });
    }
  });
});


// Product card colors swiper carousel
class CardColorsSwiper extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.options = {};
    this.colors = null;
    this.isOptimized = false;
    this.debounceTimer = null;
    this.resizeHandler = null;
  }

  connectedCallback() {
    this.colors = this.querySelectorAll('.color-swatch');
    const colorsSwiperWrapper = this.querySelector('.swiper-wrapper');
    const isOptimized = this.dataset.optimize;
    this.isOptimized = isOptimized;

    // reordering swatches
    let group1 = ``;
    let group2 = ``;

    this.colors.forEach((swatch) => {
      if (swatch.classList.contains('color--active') || group2 !== '') {
        group2 += `<div class="swiper-slide">${swatch.outerHTML}</div>`;
      }

      if(group2 === '') {
        group1 += `<div class="swiper-slide">${swatch.outerHTML}</div>`;
      }
    });

    colorsSwiperWrapper.innerHTML = group2 + group1;

    // append available colors like +67 in the slides to show when in optimize mode
    if(isOptimized) {
      const totalColorsXL = parseInt(this.dataset.totalColorsXl) || 0; // only for pdp recs
      const totalColorsLarge = parseInt(this.dataset.totalColorsLarge) || 0;
      const totalColorsMedium = parseInt(this.dataset.totalColorsMedium) || 0;
      const totalColorsSmall = parseInt(this.dataset.totalColorsSmall) || 0;

      if (totalColorsLarge > 0) {
        colorsSwiperWrapper.innerHTML += `
          <div class="swiper-slide remaining-colors-count colors-count-large">
            +${totalColorsLarge}
          </div>
        `;
      }

      if (totalColorsMedium > 0) {
        colorsSwiperWrapper.innerHTML += `
          <div class="swiper-slide remaining-colors-count colors-count-medium">
            +${totalColorsMedium}
          </div>
        `;
      }

      if (totalColorsSmall > 0) {
        colorsSwiperWrapper.innerHTML += `
          <div class="swiper-slide remaining-colors-count colors-count-small">
            +${totalColorsSmall}
          </div>
        `;
      }

      if (totalColorsXL > 0) {
        colorsSwiperWrapper.innerHTML += `
          <div class="swiper-slide hidden remaining-colors-count colors-count-xl">
            +${totalColorsXL}
          </div>
        `;
      }
    }

    // binding events
    this.swatches = this.querySelectorAll('.color-swatch'); // colors after reordering

    this.swatches.forEach((swatch) => {
      if (!isOptimized) {
        swatch.addEventListener('mouseover', this.onMouseOverChange.bind(this));
        swatch.addEventListener('mouseout', this.onMouseOutChange.bind(this));
      }

      swatch.addEventListener('click', this.onMouseOverChange.bind(this));
    })

    // this.reorderSwatches();
    this.initSlider();

    this.calculateSwatchSizes();
    this.setupResizeListener();
  }

  calculateSwatchSizes() {
    const colorsList = this.querySelector('.card__colors-list');
    if (!colorsList) return;

    const cardWrapper = this.closest('.card-wrapper');
    if (!cardWrapper) return;

    const stylesVariables = `
      --swatch-container-height: ${colorsList.clientHeight}px;
      --swatch-top-position: -${colorsList.clientHeight}px;
    `;

    cardWrapper.setAttribute('style', stylesVariables);
  }

  setupResizeListener() {
    // Create a debounced resize handler
    this.resizeHandler = () => {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      
      this.debounceTimer = setTimeout(() => {
        this.calculateSwatchSizes();
      }, 150);
    };

    // Add resize event listener
    window.addEventListener('resize', this.resizeHandler);
  }

  disconnectedCallback() {
    // Clean up resize event listener
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    
    // Clear any pending debounce timers
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }

  onMouseOverChange(e) {
    e.preventDefault();

    // preventing mouseover event from touch devices to prevent double event trigger
    if (!window.matchMedia("(hover: hover)").matches && e.type === 'mouseover') return;

    // For touch devices like mobile and tablet
    if (!window.matchMedia("(hover: hover)").matches && e.type === 'click') {
      if (this.dataset.swatchChangeMobile === 'false') {
        // redirect to the product page
        location.href = e.target.dataset.href;
      } else {
        e.preventDefault();
      }
    }

    if(e.type === 'click') {
      if(this.isOptimized) {
        location.href = e.target.dataset.href;
        return;
      }

      this.swatches.forEach((swatch) => { swatch.classList.remove('color--active') });
      e.currentTarget.classList.add('color--active');
    }

    this.updateCardDetails(e.target, e.type);
  }

  onMouseOutChange(e) {
    const parentEl = e.target.closest('.card-wrapper');
    const current_active_color = parentEl.querySelector('.color--active');

    this.updateCardDetails(current_active_color, e.type);
  }

  updateCardDetails(el, eType='') {
    const parentEl = el.closest('.card-wrapper');
    const cardImagesSlider = parentEl.querySelector('card-product-images');
    const swatch_group = el.dataset.swatchGroup;
    const product_title = el.dataset.productTitle;
    const short_text = el.dataset.shortText;
    const color_name = el.dataset.value;
    const size = el.dataset.size;
    const link = el.dataset.href;
    const image = el.dataset.imageLarge;
    const isAvailable = el.dataset.available;

    if(el.dataset.productImages && eType === 'click') {
      const images = JSON.parse(el.dataset.productImages);
      const loopSize = images.length > 2 ? 3 : images.length;

      let colorImageSlides = ``;
      for(var i=0; i<loopSize;i++) {
        let formattedImage = images[i].replace('.png', '_600x.png').replace('.jpg', '_600x.jpg');
        colorImageSlides += `<div class="swiper-slide">
          <img src="${formattedImage}" />
        </div>`
      }

      cardImagesSlider.slider = null;
      cardImagesSlider.innerHTML = `<div class="swiper" data-slider>
        <div class="swiper-wrapper">
          ${colorImageSlides}
        </div>
        <div class="swiper-pagination medium-hide large-up-hide"></div>
      </div>`;

      cardImagesSlider.initSlider()
    }

    // updates the anchor tag href
    parentEl.querySelector('.card--link').setAttribute('href', link);

    // updates the product title
    parentEl.querySelector('.card__heading').innerHTML = product_title;

    // updates the Swatch group and color name
    parentEl.querySelector('.card__short-text').innerHTML = short_text;
    const colorNameWrappers = parentEl.querySelectorAll('.card__current-color');
    colorNameWrappers.forEach(el => el.innerHTML = color_name);

    // updates the featured image
    parentEl.querySelectorAll('.card__media .image picture source').forEach((el) => el.remove());
    parentEl.querySelector('.card__media .image img.image__img').removeAttribute('srcset');
    parentEl.querySelector('.card__media .image img.image__img').removeAttribute('sizes');
    parentEl.querySelector('.card__media .image img.image__img').src = image;

    parentEl.setAttribute('data-available', isAvailable);

    // Hide the quick buy button if the product is preorder
    if (typeof el.dataset.isPreorder !== 'undefined') {
      parentEl.querySelector('product-form').classList.add('hidden');
    } else {
      parentEl.querySelector('product-form').classList.remove('hidden');
    }

    // Update price HTML
    const priceHtml = el.querySelector('[data-price-html]').innerHTML;
    parentEl.querySelector('.card__information-price').innerHTML = priceHtml;

    // updated the variant id
    parentEl.querySelectorAll('[name="id"]').forEach((input) => {
      input.value = el.dataset.variantId;
    });
  }

  initSlider() {
    if (!this.querySelector('[data-slider]')) return;
    // Initialize the Swiper slider
    this.options = {
      slidesPerView: 'auto', // Show as many slides as fit within the container
      spaceBetween: 0,
      slidesPerGroup: 5,
      loop: true,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next'),
      },
    };

    // Initialize the Swiper slider
    this.slider = new Swiper(
      this.querySelector('.swiper'), // Pass the slider element
      this.options, // Pass the configuration options
    );
  }
};

customElements.define('card-colors-swiper', CardColorsSwiper);

class cardProductImagesSwiper extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.options = {};
    this.card = this.closest('.card-wrapper');
    this.observer = null;

    this.card.addEventListener('mouseover', () => {
      if (!this.canHover()) return;
      if (!this.slider) {
        this.initSlider();
      }
      this.slider.slideTo(1);
    });

    this.card.addEventListener('mouseleave', () => {
      if (!this.canHover() || !this.slider) return;
      this.slider.slideTo(0, 0);
    });
  }

  canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  initSlider() {
    const isMobile = window.outerWidth <= 989;

    this.options = {
      slidesPerView: 1, // Show as many slides as fit within the container
      spaceBetween: 0,
      loop: false,
      nested: true, // Hand off touch gestures to an ancestor Swiper (e.g. categories-scroll's product tray)
      pagination: {
        el: ".swiper-pagination",
      },
    };

    if (!isMobile) {
      this.options.effect = 'fade';
      this.options.fadeEffect = { crossFade: true };
    }

    // Initialize the Swiper slider
    this.slider = new Swiper(
      this.querySelector('.swiper'), // Pass the slider element
      this.options, // Pass the configuration options
    );
  }

  connectedCallback() {
    if (window.outerWidth <= 989 && !this.slider) {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              if (!this.slider) {
                this.initSlider();
              }
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px',
        }
      );

      this.observer.observe(this);
    }
  }
};

customElements.define('card-product-images', cardProductImagesSwiper);

if(!customElements.get('card-product-mini')) {
  class CardProductMini extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.onSwatchSelection);
      this.renderTabs();
      this.bindEvents();
    }

    renderTabs() {
      // only render tabs if tabs are enabled
      if(!this.classList.contains('card-product-mini__tabs-active')) return;

      const swatchesWrapper = this.querySelector('.card-product-mini__swatches-wrapper');
      if(!swatchesWrapper) return;

      const allSwatchGroups = swatchesWrapper.querySelectorAll('.card-product-mini__swatches');
      if(allSwatchGroups.length <= 1) return; // Only show tabs if there's more than one group

      // Get all unique groups
      const tabsArray = [];
      allSwatchGroups.forEach((group) => {
        const groupName = group.dataset.groupName;
        const groupId = group.dataset.groupId;
        if(groupName && !tabsArray.some(tab => tab.id === groupId)) {
          tabsArray.push({
            name: groupName,
            id: groupId
          });
        }
      });

      if(tabsArray.length <= 1) return; // Only show tabs if there's more than one group

      // Get default selected group
      const defaultSelectedGroup = swatchesWrapper.querySelector('[data-group-selected="true"]');
      const defaultSelectedId = defaultSelectedGroup?.dataset.groupId;

      // Create tabs HTML
      let innerTabsHtml = '';
      tabsArray.forEach((tab, i) => {
        const isSelected = tab.id === defaultSelectedId;
        innerTabsHtml += `
          <div class="swiper-slide">
            <button
              role="tab"
              id="card-mini-tab-${tab.id}-${i}"
              aria-selected="${isSelected ? 'true' : 'false'}"
              aria-controls="${tab.id}"
              class="tab"
              data-group-id="${tab.id}">
              ${tab.name}
            </button>
          </div>
        `;
      });

      // Create tabs wrapper
      const tabs = document.createElement('div');
      tabs.classList.add('card-product-mini__tabs-wrapper');
      tabs.innerHTML = `
        <div class="card-product-mini__tabs">
          <div class="swiper">
            <div class="tabs swiper-wrapper" data-role="tablist">
              ${innerTabsHtml}
            </div>
          </div>
        </div>
      `;

      swatchesWrapper.prepend(tabs);
      this.bindTabEvents();
    }

    bindTabEvents() {
      const tabsWrapper = this.querySelector('.card-product-mini__tabs-wrapper');
      if(!tabsWrapper) return;

      const swatchesWrapper = this.querySelector('.card-product-mini__swatches-wrapper');
      if(!swatchesWrapper) return;

      const tabs = tabsWrapper.querySelectorAll('[role="tab"]');
      const allSwatchGroups = swatchesWrapper.querySelectorAll('.card-product-mini__swatches');

      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          // Update tab states
          tabs.forEach((t) => {
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });
          e.target.setAttribute('aria-selected', 'true');
          e.target.setAttribute('tabindex', '0');

          const selectedId = e.target.dataset.groupId;

          // Show/hide swatch groups
          allSwatchGroups.forEach((group) => {
            if(group.dataset.groupId === selectedId) {
              group.classList.remove('hidden');
            } else {
              group.classList.add('hidden');
            }
          });
        });

        // Keyboard navigation
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const currentTab = e.target;
            let nextTab;
            if (e.key === 'ArrowRight') {
              nextTab = currentTab.nextElementSibling;
              if (!nextTab) {
                nextTab = tabs[0];
              }
            } else {
              nextTab = currentTab.previousElementSibling;
              if (!nextTab) {
                nextTab = tabs[tabs.length - 1];
              }
            }
            nextTab.focus();
            nextTab.click();
          }
        });
      });

      // Initially hide non-selected groups and ensure color name is displayed
      const selectedTab = tabsWrapper.querySelector('.tab[aria-selected="true"]');
      if(selectedTab) {
        const selectedId = selectedTab.dataset.groupId;
        allSwatchGroups.forEach((group) => {
          if(group.dataset.groupId !== selectedId) {
            group.classList.add('hidden');
          }
        });
      }
    }

    bindEvents() {
      const swatchOptions = this.querySelectorAll('.swatch-group__option label');

      swatchOptions.forEach((option) => {
        option.addEventListener('mouseover', this.onMouseOverOutChange.bind(this));
        option.addEventListener('mouseout', this.onMouseOverOutChange.bind(this));
      });

      const buyButton = this.querySelector('.button-card-product-mini-submit');

      if(buyButton) {
        buyButton.addEventListener('click', this.onSubmit.bind(this))
      }

      let selectedInput = this.querySelector('.swatch-group__option input:checked');

      // if the actual selected color is not printed due to exclusion from the everywhere added in settings.hide_colors
      if(!selectedInput) {
        selectedInput = this.querySelectorAll('.card-product-mini__swatches:not(.hidden) input[type="radio"]')[0];
        if(selectedInput) {
          selectedInput.checked = true;
          selectedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // If selected swatch is out of stock then select the next available swatch
      if(selectedInput && selectedInput.classList.contains('out-of-stock')) {
        const swatchGroupWrapper = selectedInput.closest('.card-product-mini__swatches');
        const groupSwatches = Array.from(swatchGroupWrapper.querySelectorAll('.swatch-group__option input'));
        const selectedInputIndex = groupSwatches.findIndex(el => el === selectedInput);

        let nextAvailableSwatch =  null;

        for (let i = selectedInputIndex + 1; i < groupSwatches.length; i++) {
          if (!groupSwatches[i].classList.contains('out-of-stock')) {
            nextAvailableSwatch = groupSwatches[i];
            break; // Select next available swatch
          }
        }

        // If no next available swatch is found, start searching from the beginning
        if(!nextAvailableSwatch) {
          for (let i = 0; i < selectedInputIndex; i++) {
            if (!groupSwatches[i].classList.contains('out-of-stock')) {
              nextAvailableSwatch = groupSwatches[i];
              break; // Select next available swatch
            }
          }
        }

        if(nextAvailableSwatch) {
          nextAvailableSwatch.click();
        }
      }
    }

    onSwatchSelection(e) {
      const el = e.target;

      this.updateDetails(el, 'click');
    }

    onMouseOverOutChange(e) {
      if(!deviceSupportHover()) return;

      const parentWrapper = e.target.closest('details');
      let inputEl = e.target.closest('.swatch-group__option').querySelector('input');

      if(e.type === 'mouseout') {
        inputEl = parentWrapper.querySelector('input:checked');
      }

      this.updateDetails(inputEl);
    }

    updateDetails(el, eType = null) {
      const parentWrapper = el.closest('details');

      // Updating the featured image
      const featuredImage = parentWrapper.querySelector('.card-product-mini__featured-image img');
      featuredImage.src = el.dataset.colorImage;

      const selectedColorNameSelector = parentWrapper.querySelectorAll('[js-selected-color]')
      if(selectedColorNameSelector.length > 0 && el.dataset.colorName) {
        selectedColorNameSelector.forEach((selector) => {
          selector.innerHTML = el.dataset.colorName;
          selector.dataset.selectedColor = el.dataset.colorName;
        });
      }

      // updating price
      const priceWrapper = parentWrapper.querySelector('.card-product-mini__price');
      const isFakeMarkdown = el.dataset.colorIsFakeMarkdown === 'true';
      const comparePrice = el.dataset.colorComparePrice;
      const price = el.dataset.colorPrice;

      // A discounted bundle rounds its rows against the buy button's total, which needs all of the rows
      // at once, so bundles.js renders them together and a selection hands off to it. Only a hover
      // preview is written here, and mouseout brings the rounded set back.
      const bundleContainer = el.closest('.bundle__product-container');
      const bundleDiscountPercentage = bundleContainer
        ? Number(bundleContainer.dataset.bundleDiscountPercentage) || 0
        : 0;
      const hasBundleDiscount = bundleDiscountPercentage > 0 && bundleDiscountPercentage <= 100;

      if(hasBundleDiscount && el.checked && typeof window.renderBundleRowPrices === 'function') {
        window.renderBundleRowPrices(bundleContainer);
      } else if(hasBundleDiscount) {
        const rowPrice = Number(price);
        const discountedPrice = Math.round((rowPrice - (rowPrice * bundleDiscountPercentage) / 100) / 100) * 100;
        priceWrapper.innerHTML = `<s class="price--real-markdown">${formatProductPriceNoZeros(price)}</s>`
          + `<span style="color: var(--markdown-price-color);">${formatProductPriceNoZeros(discountedPrice)}</span>`;
      } else if(comparePrice && comparePrice !== price) {
        let priceHtml = `<s>${formatProductPriceNoZeros(comparePrice)}</s>`;
        const priceColor = isFakeMarkdown ? 'var(--fake-markdown-price-color)' : 'var(--markdown-price-color)';
        priceHtml += `<span style="color: ${priceColor};">${formatProductPriceNoZeros(price)}</span>`;
        priceWrapper.innerHTML = priceHtml;
      } else {
        priceWrapper.innerHTML = `<span>${formatProductPriceNoZeros(price)}</span>`;
      }

      if(eType === 'click' && parentWrapper.querySelector('.card-product-mini__actions')) {
        const isAvailable = el.dataset.available;
        const buyButton = parentWrapper.querySelector('button.button-card-product-mini-submit');

        if(buyButton) {
          if(isAvailable === 'true') {
            buyButton.removeAttribute('disabled');
          } else {
            buyButton.setAttribute('disabled', true);
          }
        };

        parentWrapper.querySelector('.card-product-mini__actions a').setAttribute('href', el.dataset.href)
        if(isAvailable === 'true') { // Product is available
          buyButton?.classList.remove('hidden');
          parentWrapper.querySelector('modal-opener')?.classList.add('hidden');
        } else { // Product is out of stock
          buyButton?.classList.add('hidden');
          parentWrapper.querySelector('modal-opener')?.classList.remove('hidden');
          // find input[name="variant"] and input[name="product"] within <modal-stock-notify> and set the value to the selected product id and variant id
          const modalStockNotify = this.querySelector('modal-stock-notify');
          if (modalStockNotify && typeof modalStockNotify.syncSelectedProduct === 'function') {
            modalStockNotify.syncSelectedProduct({
              variantId: el.value,
              productId: el.dataset.productId,
              productTitle: el.dataset.productTitle,
              colorway: el.dataset.colorName,
            });
          } else if (modalStockNotify) {
            modalStockNotify.querySelector('input[name="variant"]').value = el.value;
            modalStockNotify.querySelector('input[name="product"]').value = el.dataset.productId;
          }
        }
      }
    }

    onSubmit() {
      const parentWrapper = this;
      let itemProperties = {};
      const properties = this.querySelectorAll('[data-property-key]');

      if(properties.length > 0){
        properties.forEach((property) => {
          const propertyKey = property.dataset.propertyKey;
          const propertyValue = property.value;

          if(propertyValue) {
            itemProperties[propertyKey] = propertyValue;
          }
        });
      }

      const data = {
        id: parseInt(parentWrapper.querySelector('input:checked').value),
        quantity: 1,
        properties: itemProperties
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      })
      .then(() => {
        window.theme.fetchAndOpenCart();
        parentWrapper.querySelector('details').removeAttribute('open')
        parentWrapper.querySelector('details').classList.add('added')
      })
      .catch((err) => console.error("Cart update failed:", err));;
    }
  }

  customElements.define('card-product-mini', CardProductMini)
}

window.cartTrapFocus = function() {
  let cartDrawer = document.querySelector('#mini-cart > div[role="dialog"]');
  if (!cartDrawer) return;

  let focusableElements = cartDrawer.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length === 0) return;

  let firstFocusableElement = focusableElements[0];
  let lastFocusableElement = focusableElements[focusableElements.length - 1];

  cartDrawer.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
          if (e.shiftKey && e.target === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus(); // Shift+Tab loops to last element
          } else if (!e.shiftKey && e.target === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus(); // Tab loops to first element
          }
      }
  });
}

// Prevent wishlist button from navigating to product page
document.addEventListener('click', function(event) {
  // Check if the clicked element is a wishlist button or its child
  const wishlistButton = event.target.closest('wishlist-button-collection .wk-button');

  if (wishlistButton) {
    // Stop the event from bubbling up to the card link
    event.preventDefault();
    event.stopPropagation();
  }
});
